import moment from 'moment';
import LoginHandler from 'javascripts/globals/login-handler';
import { createRoot } from 'react-dom/client';
import React from 'react';
import CommentPreview from 'components/organisms/comment/react/CommentPreview';
import { registerHtml5Validation } from 'javascripts/utils/form-validation';

/**
 * Initialize legacy comment preview functionality
 * @param {HTMLElement} $trigger - The preview button element
 */
export function initCommentPreview($initButton) {
  const $trigger = $initButton;
  const $formbox = $trigger.closest('.comment-list__box');
  if (!$formbox) return;

  const $form = $formbox.querySelector('.form');
  const userName = $formbox.getAttribute('data-user-name');
  const $commentList = $trigger.closest('.comment-list');
  const $commentControls = $commentList?.querySelector(
    '.comment-list__controls',
  );
  const $commentsEmpty = $commentControls?.querySelector(
    '.comment__text--empty',
  );
  const $subject = $formbox.querySelector('#subject');
  const $text = $formbox.querySelector('#text');

  let $previewContainer = null;
  let root = null;

  const redirectToLogin = () => {
    const $link = document.querySelector('#js-bp-login a');
    const loginUrl = $link ? $link.getAttribute('href') : '/';
    window.location.href = loginUrl;
  };

  const handleEdit = () => {
    if ($previewContainer) {
      $previewContainer.parentNode?.removeChild($previewContainer);
      $previewContainer = null;
    }
    if ($commentsEmpty && $commentControls) {
      $commentControls.appendChild($commentsEmpty);
    }

    // enable form
    if ($subject) $subject.disabled = false;
    if ($text) $text.disabled = false;
    $trigger.disabled = false;
    $trigger.setAttribute('style', 'display: inline-flex;');

    // jump to form
    if ($formbox) {
      window.scrollTo({
        top: $formbox.offsetTop - 30,
        behavior: 'smooth',
      });
      $subject?.focus();
    }
  };

  const handleSubmit = () => {
    handleEdit();
    $trigger.disabled = true;
    $form?.submit();
    setTimeout(() => {
      $trigger.disabled = false;
    }, 8000);
  };

  const showPreview = (e) => {
    e.preventDefault();

    const loginState = LoginHandler.getLoginStateFromWindow();
    if (loginState === false) {
      redirectToLogin();
      return;
    }

    const isFormValid = $form.checkValidity();
    if (!isFormValid) {
      $form.querySelector('*[aria-invalid="true"]')?.focus();
      return;
    }

    if ($subject && $text) {
      moment.locale('de');
      const date = moment().format('DD.MM.YYYY');
      const time = moment().format('HH:mm');

      // Create container for React preview
      $previewContainer = document.createElement('div');
      $previewContainer.setAttribute('tabindex', '0');

      if ($commentControls) {
        $commentControls.parentNode?.insertBefore(
          $previewContainer,
          $commentControls.nextSibling,
        );

        if ($commentsEmpty) {
          $commentsEmpty.parentNode?.removeChild($commentsEmpty);
        }

        // Render React component
        root = createRoot($previewContainer);
        root.render(
          <CommentPreview
            subject={$subject.value}
            text={$text.value}
            userName={userName || 'Ohne Name'}
            onEdit={handleEdit}
            onSubmit={handleSubmit}
          />,
        );

        // jump to element
        window.scrollTo({
          top: $previewContainer.offsetTop - 30,
          behavior: 'smooth',
        });
        $previewContainer.focus();

        // disable form
        $subject.disabled = true;
        $text.disabled = true;
        $trigger.disabled = true;
        $trigger.setAttribute('style', 'display: none;');
      }
    }
  };

  registerHtml5Validation($form, $trigger);
  $trigger.addEventListener('click', showPreview);
}

export default initCommentPreview;
